import SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS from '@store/constants/settlementServiceDashboardConstants';

const initialState = {
  // Dashboard Commons
  commons : {
    data: [],
    isLoading: false,
    error: false
  },

  // Client Management State
  clients: {
    data: [],
    isLoading: false,
    error: null
  },
  
  clientDetails: {
    data: null,
    isLoading: false,
    error: null
  },

  // Ledger Management State
  ledgers: {
    data: [],
    isLoading: false,
    error: null
  },

  ledgerDetails: {
    data: null,
    isLoading: false,
    error: null
  },

  // Account Operations State
  accounts: {
    data: [],
    isLoading: false,
    error: null
  },

  accountDetails: {
    data: null,
    isLoading: false,
    error: null
  },
};

const settlementServiceDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // General Config
    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GETTING_COMMONS_CONFIG:
      return {
        ...state,
        commons : {
          ...state.commons,
          isLoading: true,
          error: false
        }
      }

      case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_COMMONS_CONFIG_SUCCESS:
        return {
          ...state,
          commons : {
            ...state.commons,
            isLoading: false,
            data: action.payload,
            error: false
          }
        }

      case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_COMMONS_CONFIG_FAILURE:
        return {
          ...state,
          commons : {
            ...state.commons,
            isLoading: true,
            error: false
          }
        }

    // Client Management Reducers
    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GETTING_CLIENTS:
      return {
        ...state,
        clients: {
          ...state.clients,
          isLoading: true,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: {
          ...state.clients,
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_CLIENTS_FAILURE:
      return {
        ...state,
        clients: {
          ...state.clients,
          isLoading: false,
          error: action.payload
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.RESET_CLIENTS_DATA:
      return {
        ...state,
        clients: initialState.clients
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GETTING_CLIENT_DETAILS:
      return {
        ...state,
        clientDetails: {
          ...state.clientDetails,
          isLoading: true,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_CLIENT_DETAILS_SUCCESS:
      return {
        ...state,
        clientDetails: {
          ...state.clientDetails,
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_CLIENT_DETAILS_FAILURE:
      return {
        ...state,
        clientDetails: {
          ...state.clientDetails,
          isLoading: false,
          error: action.payload
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.RESET_CLIENT_DETAILS_DATA:
      return {
        ...state,
        clientDetails: initialState.clientDetails
      };

    // Ledger Management Reducers
    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GETTING_LEDGERS:
      return {
        ...state,
        ledgers: {
          ...state.ledgers,
          isLoading: true,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_LEDGERS_SUCCESS:
      return {
        ...state,
        ledgers: {
          ...state.ledgers,
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_LEDGERS_FAILURE:
      return {
        ...state,
        ledgers: {
          ...state.ledgers,
          isLoading: false,
          error: action.payload
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.RESET_LEDGERS_DATA:
      return {
        ...state,
        ledgers: initialState.ledgers
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GETTING_LEDGER_DETAILS:
      return {
        ...state,
        ledgerDetails: {
          ...state.ledgerDetails,
          isLoading: true,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_LEDGER_DETAILS_SUCCESS:
      return {
        ...state,
        ledgerDetails: {
          ...state.ledgerDetails,
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_LEDGER_DETAILS_FAILURE:
      return {
        ...state,
        ledgerDetails: {
          ...state.ledgerDetails,
          isLoading: false,
          error: action.payload
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.RESET_LEDGER_DETAILS_DATA:
      return {
        ...state,
        ledgerDetails: initialState.ledgerDetails
      };

    // Account Operations Reducers
    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GETTING_ACCOUNTS:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          isLoading: true,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_ACCOUNTS_FAILURE:
      return {
        ...state,
        accounts: {
          ...state.accounts,
          isLoading: false,
          error: action.payload
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.RESET_ACCOUNTS_DATA:
      return {
        ...state,
        accounts: initialState.accounts
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GETTING_ACCOUNT_DETAILS:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          isLoading: true,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.GET_ACCOUNT_DETAILS_FAILURE:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          isLoading: false,
          error: action.payload
        }
      };

    case SETTLEMENT_SERVICE_DASHBOARD_CONSTANTS.RESET_ACCOUNT_DETAILS_DATA:
      return {
        ...state,
        accountDetails: initialState.accountDetails
      };

    default:
      return state;
  }
};

export default settlementServiceDashboardReducer; 